"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableContentAnimations = disableContentAnimations;
exports.enablePresenterAnimations = enablePresenterAnimations;
exports.findSoloSource = findSoloSource;
exports.findSourceByType = findSourceByType;
exports.getFeaturedMediaOrScreen = getFeaturedMediaOrScreen;
exports.getSourceByType = getSourceByType;
exports.getSourceCountByType = getSourceCountByType;
exports.hasOneCameraPresenter = hasOneCameraPresenter;
exports.hasOneMediaSource = hasOneMediaSource;
exports.hasOneScreenPresenter = hasOneScreenPresenter;
exports.isFeaturedMediaOrScreen = isFeaturedMediaOrScreen;
exports.isSameSource = isSameSource;
exports.isSceneLayer = isSceneLayer;
exports.isSceneLayout = isSceneLayout;
exports.isSolo = isSolo;
exports.isSoloCameraPresenter = isSoloCameraPresenter;
exports.isSoloMedia = isSoloMedia;
exports.isSoloScreenPresenter = isSoloScreenPresenter;
exports.replaceSource = replaceSource;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../utils");
var _constants = require("../../constants/");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Formerly, the scene layout type was saved in the id property of the scene
 * We also have scene layout type now saved in the layout property of the scene
 * @param {{}} scene
 * @param {{}} layout
 */
function isSceneLayout(scene, layout) {
  if (Array.isArray(layout)) {
    return layout.includes(scene._id);
  }
  return scene._id === layout.id || (scene === null || scene === void 0 ? void 0 : scene.layout) === layout.id;
}

/**
 * @param {{}} scene
 */
function isFeaturedMediaOrScreen(scene) {
  return isSceneLayout(scene, _constants.FEATURED_MEDIA) || isSceneLayout(scene, _constants.FEATURED_SCREEN);
}

/**
 * @param {{}} source1
 * @param {{}} source2
 */
function isSameSource(source1, source2) {
  var _source1$source, _source2$source;
  return ((_source1$source = source1.source) === null || _source1$source === void 0 ? void 0 : _source1$source._id) === ((_source2$source = source2.source) === null || _source2$source === void 0 ? void 0 : _source2$source._id);
}

/**
 * Replace a source in program with a new source
 * @param {{}} scene - current scene
 * @param {string} sourceId - source id of the source to be replaced
 * @param {{}} newSource - new source
 * @returns scene
 */
function replaceSource() {
  var scene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sourceId = arguments.length > 1 ? arguments[1] : undefined;
  var newSource = arguments.length > 2 ? arguments[2] : undefined;
  var newScene = _objectSpread({}, scene);
  newScene.layers = scene.layers.map(function (layerSource) {
    return layerSource._id === sourceId ? newSource : layerSource;
  });
  return newScene;
}

/**
 * Find a solo source
 * @param {{}} scene
 * @returns a layer source or undefined
 */
function findSoloSource(scene) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers === null || layers === void 0 ? void 0 : layers.find(function (layerSource) {
    return !isSceneLayer(layerSource);
  });
}

/**
 * Find source by type
 * @param {{}} scene: Current scene
 * @param {string} sourceType: source type to check in a scene
 * @returns Layer or undefined
 */
function findSourceByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers === null || layers === void 0 ? void 0 : layers.find(function (layerSource) {
    var _layerSource$source;
    return (layerSource === null || layerSource === void 0 ? void 0 : (_layerSource$source = layerSource.source) === null || _layerSource$source === void 0 ? void 0 : _layerSource$source.type) === sourceType;
  });
}

/**
 * @param {{}} scene
 * @param {string} sourceType
 */
function getSourceByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  return layers.filter(function (layerSource) {
    var _layerSource$source2;
    return (layerSource === null || layerSource === void 0 ? void 0 : (_layerSource$source2 = layerSource.source) === null || _layerSource$source2 === void 0 ? void 0 : _layerSource$source2.type) === sourceType && !isSceneLayer(layerSource);
  });
}

/**
 * @param {{}} scene
 * @param {string} sourceType
 */
function getSourceCountByType(scene, sourceType) {
  var layers = (0, _utils.getProgramLayers)(scene);
  if (layers !== null && layers !== void 0 && layers.length) {
    var matches = layers.filter(function (layerSource) {
      var _layerSource$source3;
      return (layerSource === null || layerSource === void 0 ? void 0 : (_layerSource$source3 = layerSource.source) === null || _layerSource$source3 === void 0 ? void 0 : _layerSource$source3.type) === sourceType && !isSceneLayer(layerSource);
    });
    return matches.length;
  }
  return 0;
}

/**
 * @param {{}} scene
 * @param {Function} predicate
 */
function isSolo(scene, predicate) {
  var _scene$layers;
  if (scene !== null && scene !== void 0 && scene.layers && (_scene$layers = scene.layers) !== null && _scene$layers !== void 0 && _scene$layers.length) {
    return isSceneLayout(scene, _constants.SINGLE) && predicate(scene);
  }
  return false;
}

/**
 * @param {{}} scene
 */
function isSoloScreenPresenter(scene) {
  return isSolo(scene, hasOneScreenPresenter);
}

/**
 * @param {{}} scene
 */
function isSoloCameraPresenter(scene) {
  return isSolo(scene, hasOneCameraPresenter);
}

/**
 * @param {{}} scene
 */
function isSoloMedia(scene) {
  return isSolo(scene, hasOneMediaSource);
}

/**
 * @param {{}} scene
 */
function hasOneMediaSource(scene) {
  return getSourceCountByType(scene, _constants.IMAGE_FILE) + getSourceCountByType(scene, _constants.PDF_FILE) + getSourceCountByType(scene, _constants.VIDEO_FILE) === 1;
}

/**
 * @param {{}} scene
 */
function hasOneScreenPresenter(scene) {
  return getSourceCountByType(scene, _constants.SCREEN_PRESENTER) === 1;
}

/**
 * @param {{}} scene
 */
function hasOneCameraPresenter(scene) {
  return getSourceCountByType(scene, _constants.CAMERA_PRESENTER) === 1;
}

/**
 * Determine if a source is an overlay, background or banner
 * @param {{}} source
 */
function isSceneLayer(source) {
  var _source$layer;
  // overlays, backgrounds and banners have "layer.isContent" property set to false
  return (source === null || source === void 0 ? void 0 : (_source$layer = source.layer) === null || _source$layer === void 0 ? void 0 : _source$layer.hasOwnProperty('isContent')) && source.layer.isContent === false;
}

/**
 * @param {{}} scene
 */
function getFeaturedMediaOrScreen(scene) {
  if (isFeaturedMediaOrScreen && scene && scene.layers) {
    return scene.layers.find(function (layerSource) {
      var _layerSource$source4;
      return (layerSource === null || layerSource === void 0 ? void 0 : (_layerSource$source4 = layerSource.source) === null || _layerSource$source4 === void 0 ? void 0 : _layerSource$source4.type) !== _constants.CAMERA_PRESENTER && !isSceneLayer(layerSource);
    });
  }
}

/**
 * @param {{}} scene
 */
function enablePresenterAnimations(scene) {
  var next = scene;
  var nextCameraPresenters = getSourceByType(scene, _constants.CAMERA_PRESENTER);
  var _iterator = _createForOfIteratorHelper(nextCameraPresenters),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var camera = _step.value;
      camera.layer.animation.transition = _utils.DEFAULT_ANIMATION.transition;
      next = replaceSource(next, camera._id, camera);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return next;
}

/**
 * Disable animations for layer sources that are content i.e. they're not
 * overlays, backgrounds or banners.
 * @param {{}} scene
 * @param  sourceTypes
 * @returns {{}}
 */
function disableContentAnimations(scene) {
  var _scene$layers2;
  var sourceTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  scene.layers = (_scene$layers2 = scene.layers) === null || _scene$layers2 === void 0 ? void 0 : _scene$layers2.map(function (layerSource) {
    var _layerSource$source5;
    if (sourceTypes.includes(layerSource === null || layerSource === void 0 ? void 0 : (_layerSource$source5 = layerSource.source) === null || _layerSource$source5 === void 0 ? void 0 : _layerSource$source5.type) && !isSceneLayer(layerSource)) {
      layerSource.layer.animation.transition = _utils.HARD_CUT_ANIMATION.transition;
      return layerSource;
    }
    return layerSource;
  });
  return scene;
}